import useLogoutLink from '@hellodarwin/app-core/lib/hooks/use-logout-link';
import DesktopUserMenu from '@hellodarwin/app-core/lib/layouts/app-layout/components/user-menu/desktop';
import Button from '@hellodarwin/core/lib/components/common/button';
import { Tablet } from '@hellodarwin/core/lib/components/common/Media';
import { Contact } from '@hellodarwin/core/lib/features/entities';
import { Language } from '@hellodarwin/core/lib/features/entities/translations_ns';
import SingleLanguage from '@hellodarwin/core/lib/features/enums/single-language';
import useLocale, {
  getOtherLocale,
} from '@hellodarwin/core/lib/features/providers/locale-provider';
import HdLogo from '@hellodarwin/icons/dist/icons/HdLogo';
import ConfigProvider from 'antd/es/config-provider';
import { useTheme } from 'styled-components';
import { useAppDispatch, useAppSelector } from '../../../../../app/app-hooks';
import {
  selectContact,
  selectProfile,
  updateContactById,
} from '../../../../../features/api/slices/profile-slice';
import { useClientApi } from '../../../../../features/api/use-client-api';
import { StyledHeader } from './styles';

const OnboardingLayoutFlowHeader = () => {
  const logoutLink = useLogoutLink();
  const theme = useTheme();

  const profile = useAppSelector(selectProfile);
  const contact = useAppSelector(selectContact);
  const dispatch = useAppDispatch();
  const { selectedLocale, changeLanguage } = useLocale();
  const api = useClientApi();

  // const otherLang = SUPPORTED_LANGUAGES.find((lang) => selectedLocale !== lang);

  const handleContactEdit = async (newLocale: string) => {
    const data = new FormData();
    const updatedContact: Contact = {
      ...contact,
      preferred_language: newLocale as SingleLanguage,
    };

    data.append('request', JSON.stringify(updatedContact));

    await dispatch(updateContactById({ api, data }));

    changeLanguage(newLocale as Language);
  };

  return (
    <ConfigProvider
      theme={{ components: { Layout: { headerPadding: '0 8px' } } }}
    >
      <StyledHeader>
        <HdLogo backgroundType={'light'} color="b/w" width={143} height={18} />

        <div style={{ display: 'flex', alignItems: 'center', gap: 16 }}>
          <>
            <Button
              defaultStyle={theme.colors.transparent}
              onClick={() =>
                handleContactEdit(getOtherLocale(selectedLocale) ?? 'en')
              }
              size="square"
              key={getOtherLocale(selectedLocale)}
              style={{
                textTransform: 'uppercase',
                width: 35,
                height: 35,
                border: 'none',
                transition: 'background 0.2s',
              }}
            >
              {getOtherLocale(selectedLocale)}
            </Button>
            <div
              style={{
                width: 1,
                height: 24,
                background: theme.colors.grey_4,
                margin: '0 0px',
                alignSelf: 'center',
              }}
            />
          </>

          <Tablet direction="up">
            <DesktopUserMenu
              user={{
                name: profile.contact_name,
                logo: profile.logo,
                email: profile.contact_email,
              }}
              links={[logoutLink]}
            />
          </Tablet>
          <Tablet direction="down">
            <DesktopUserMenu links={[logoutLink]} />
          </Tablet>
        </div>
      </StyledHeader>
    </ConfigProvider>
  );
};

export default OnboardingLayoutFlowHeader;
